import {
  redirectUnauthorizedTo,
  canActivate,
  redirectLoggedInTo,
} from '@angular/fire/auth-guard';
import { Route } from '@angular/router';
import { dashboardResolver, planGuard, workspacesResolver } from '@doddly/core';
import {
  CreateAccountComponent,
  ForgotPasswordComponent,
  SignInComponent,
  SignOutComponent,
} from '@doddly/auth';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['sign-in']);
const redirectLoggedInToDashboard = () => redirectLoggedInTo(['dashboard']);

export const appRoutes: Route[] = [
  {
    path: 'sign-in',
    component: SignInComponent,
    ...canActivate(redirectLoggedInToDashboard),
  },
  {
    path: 'sign-out',
    component: SignOutComponent,
  },
  {
    path: 'sign-up',
    component: CreateAccountComponent,
    ...canActivate(redirectLoggedInToDashboard),
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    ...canActivate(redirectLoggedInToDashboard),
  },
  {
    path: 'dashboard',
    resolve: { profile: dashboardResolver },
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () =>
      import('@doddly/dashboard').then((m) => m.dashboardRoutes),
  },
  {
    path: 'account/:accountId/workspace/:workspaceId',
    resolve: { workspaces: workspacesResolver },
    canActivate: [redirectUnauthorizedToLogin, planGuard],
    loadChildren: () =>
      import('@doddly/workspace').then((m) => m.workspaceRoutes),
  },
  {
    path: 'profile',
    resolve: { profile: dashboardResolver },
    ...canActivate(redirectUnauthorizedToLogin),
    loadChildren: () => import('@doddly/profile').then((m) => m.profileRoutes),
  },
  {
    path: 'connection',
    loadChildren: () => {
      return import('@doddly/connect').then((m) => m.connectRoutes);
    },
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
